export const fetchTarifsList = async (sessionId: string) => {
	try {
		const formData = new FormData();

		formData.append('method', 'get_tarifs');
		formData.append('session_id', sessionId);

		const API = import.meta.env.VITE_API_BASE_URL;
		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();

		return data;
	} catch (error) {
		console.error('Fetch error:', error);
	}
};
